import { spacing } from "@magicbi/ui-library";

/** Front card height and icon tile edge: design 76px = spacing 16 (64) + spacing 3 (12). Not a spacing step, so it is a component size. */
export const CARD_HEIGHT = `calc(${spacing[16]} + ${spacing[3]})`;
/** The peek of the cards behind the front one: design 36px (spacing 9). */
export const STACK_PEEK = spacing[9];
/** Whole stack: design 112px = front card + peek. */
export const STACK_HEIGHT = `calc(${CARD_HEIGHT} + ${STACK_PEEK})`;
